module.exports = __webpack_public_path__ + "img/SD.e32c583d.svg";